import { each } from '../lib/util';

class ColorBars {
    constructor(el) {
        this.el = el;
        this.colorBars = this.el.querySelectorAll('[data-js-color-bar]');
        this.scale = window.innerWidth / 1280;

        if (this.colorBars.length > 0) {
            this.init();
        }
    }

    init() {
        let cumulativeWidth = 0;
        each(this.colorBars, (el) => {
            const width = this.getScaledValue(el.offsetWidth);
            const percentage = (Math.ceil((width / window.innerWidth) * 100));
            el.dataset.originalWidth = el.offsetWidth;
            if (!el.classList.contains("fill")) {
                el.style.width = `${percentage}%`;
                el.style.maxWidth = `${percentage}%`;
                el.style.flex = `1 0 ${percentage}%`;
                cumulativeWidth += width;
            }
        });
    }

    getScaledValue(num) {
        return Math.floor(num * this.scale);
    }
}

export default ColorBars;